// ============================================================
// sendKey.ts — (Audit fix batch 1, 31 Oct) one key per send window. The send
// carries it (idempotencyKey) and a retry of the same window repeats it, so
// the server sends the email ONCE (backend lib/sendIdempotency): a retry
// after a dropped connection gets the first send's reply, never a 2nd email.
// ============================================================
export const newSendKey = (): string => {
  const c = (globalThis as { crypto?: Crypto }).crypto
  if (c && typeof c.randomUUID === 'function') return c.randomUUID()
  // Older browsers: 32 random hex digits in the UUID shape.
  const bytes = new Uint8Array(16)
  if (c && typeof c.getRandomValues === 'function') c.getRandomValues(bytes)
  else for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256)
  const h = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`
}
